export const KEY_FIGURES_LOANS_REQUESTED = 'KEY_FIGURE_LOANS_REQUESTED'
export const KEY_FIGURES_LOANS_SUCCESS = 'KEY_FIGURE_LOANS_SUCCESS'
export const KEY_FIGURES_LOANS_FAILED = 'KEY_FIGURE_LOANS_FAILED'

export const KEY_FIGURES_REPORTS_REQUESTED = 'KEY_FIGURES_REPORTS_REQUESTED'
export const KEY_FIGURES_REPORTS_SUCCESS = 'KEY_FIGURES_REPORTS_SUCCESS'
export const KEY_FIGURES_REPORTS_FAILED = 'KEY_FIGURES_REPORTS_FAILED'

export const KEY_FIGURES_ACCOUNTS_REQUESTED = 'KEY_FIGURE_ACCOUNTS_REQUESTED'
export const KEY_FIGURES_ACCOUNTS_SUCCESS = 'KEY_FIGURE_ACCOUNTS_SUCCESS'
export const KEY_FIGURES_ACCOUNTS_FAILED = 'KEY_FIGURE_ACCOUNTS_FAILED'

export const KEY_FIGURES_LIQUIDITY_REQUESTED = 'KEY_FIGURES_LIQUIDITY_REQUESTED'
export const KEY_FIGURES_LIQUIDITY_SUCCESS = 'KEY_FIGURES_LIQUIDITY_SUCCESS'
export const KEY_FIGURES_LIQUIDITY_FAILED = 'KEY_FIGURES_LIQUIDITY_FAILED'

export const KEY_FIGURES_JOINTCOSTS_REQUESTED =
  'KEY_FIGURES_JOINTCOSTS_REQUESTED'
export const KEY_FIGURES_JOINTCOSTS_SUCCESS = 'KEY_FIGURES_JOINTCOSTS_SUCCESS'
export const KEY_FIGURES_JOINTCOSTS_FAILED = 'KEY_FIGURES_JOINTCOSTS_FAILED'

export const KEY_FIGURES_UNPAIDINVOICES_REQUESTED =
  'KEY_FIGURES_UNPAIDINVOICES_REQUESTED'
export const KEY_FIGURES_UNPAIDINVOICES_SUCCESS =
  'KEY_FIGURES_UNPAIDINVOICES_SUCCESS'
export const KEY_FIGURES_UNPAIDINVOICES_FAILED =
  'KEY_FIGURES_UNPAIDINVOICES_FAILED'

export const KEY_FIGURES_OPERATINGCOSTS_REQUESTED =
  'KEY_FIGURES_OPERATINGCOSTS_REQUESTED'
export const KEY_FIGURES_OPERATINGCOSTS_SUCCESS =
  'KEY_FIGURES_OPERATINGCOSTS_SUCCESS'
export const KEY_FIGURES_OPERATINGCOSTS_FAILED =
  'KEY_FIGURES_OPERATINGCOSTS_FAILED'

export const KEY_FIGURES_RESULTS_REQUESTED = 'KEY_FIGURES_RESULTS_REQUESTED'
export const KEY_FIGURES_RESULTS_SUCCESS = 'KEY_FIGURES_RESULTS_SUCCESS'
export const KEY_FIGURES_RESULTS_FAILED = 'KEY_FIGURES_RESULTS_FAILED'

export const KEY_FIGURES_SET_ACTIVECHART_REQUESTED =
  'KEY_FIGURES_SET_ACTIVECHART_REQUESTED'
export const KEY_FIGURES_SET_ACTIVECHART_SUCCESS =
  'KEY_FIGURES_SET_ACTIVECHART_SUCCESS'

export const KEY_FIGURES_SET_LIQUIDITY_PERIOD =
  'KEY_FIGURES_SET_LIQUIDITY_PERIOD'
export const KEY_FIGURES_SET_CHART_YEAR = 'KEY_FIGURES_SET_CHART_YEAR'

export const KEY_FIGURES_CASHFLOW_INIT = 'KEY_FIGURES_CASHFLOW_INIT'
export const KEY_FIGURES_SET_CASHFLOW_ENABLED =
  'KEY_FIGURES_SET_CASHFLOW_ENABLED'

export const KEY_FIGURES_FETCH_CASHFLOW_REQUESTED =
  'KEY_FIGURES_FETCH_CASHFLOW_REQUESTED'
export const KEY_FIGURES_FETCH_CASHFLOW_SUCCESS =
  'KEY_FIGURES_FETCH_CASHFLOW_SUCCESS'
export const KEY_FIGURES_FETCH_CASHFLOW_FAILED =
  'KEY_FIGURES_FETCH_CASHFLOW_FAILED'

export const KEY_FIGURES_CASHFLOW_RESET = 'KEY_FIGURES_CASHFLOW_RESET'
